import cn from "classnames"

import { CLIENT_AUTHORIZATION_PLACE } from "../../common/constant"

import { TABS_ITEMS } from "./constants"
import styles from "./style.module.scss"

interface Props {
    setIsAuthorization: (arg: boolean) => void
    isAuthorization: boolean
    isSecondPage: boolean
    place?: CLIENT_AUTHORIZATION_PLACE
}

export const Header = ({ setIsAuthorization, isAuthorization, place }: Props) => {
    const handleTabClick = (value: boolean) => {
        setIsAuthorization(value)
    }

    return (
        <div
            className={cn(styles.container, {
                [styles.isMain]: place === CLIENT_AUTHORIZATION_PLACE.MAIN,
                [styles.isModal]: place === CLIENT_AUTHORIZATION_PLACE.MODAL,
            })}
        >
            <div className={styles.header}>
                <div>
                    <h1 className={styles.headline}>Вход в Мой Alter</h1>
                    <div className={styles.tabs}>
                        {TABS_ITEMS.map(({ label, value }) => {
                            const selected = isAuthorization === value
                            return (
                                <div
                                    key={label}
                                    onClick={() => handleTabClick(value)}
                                    className={cn(styles.tab, {
                                        [styles.tabSelected]: selected,
                                    })}
                                >
                                    <div>{label}</div>
                                    {selected && <div className={styles.tabCustomBorder} />}
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}
